import { Attachment } from "../../../src";

export interface FileResponse {
    fileId: number;
    fileName: string;
    fileExtension: string;
    contentType: string;
    fileUri: string;
    createTimestamp: number;
    fileContentLength: number;
}

export const convertFriendlyFileSize = (fileContentLength: number) => {
    if (fileContentLength / 1024.0 >= 1024.0) {
        return `${(fileContentLength / 1024.0 / 1024.0).toFixed(2)} MB`;
    }
    return `${(fileContentLength / 1024.0).toFixed(2)} KB`;
};

export const convertFileResponse = (response: FileResponse) => {
    if (!response) return null;

    const attachment: Attachment = {
        contentType: response.contentType,
        createTimestamp: response.createTimestamp,
        fileExtension: response.fileExtension,
        fileId: response.fileId,
        fileName: response.fileName,
        fileUri: response.fileUri,
        fileContentLength: response.fileContentLength,
        friendlyFileSize: convertFriendlyFileSize(response.fileContentLength),
    };
    return attachment;
};
